import styled from "styled-components";

import View790AAddendumBColumns from "../columns/790A/View790AAddendumBColumns";

import { ReactTable } from "../../SimpleForm/ReactTable";
import { useEffect, useState } from "react";
import { LinkageSelectionTable } from "./LinkageSelectionTable";
import PopupMenu from "../../SimpleForm/PopupMenu";
import { saveLinkages } from "../utils";

const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  button {
    align-self: flex-start;
  }
`;

const ViewTableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0px;
  height: 30px;
`;

const Button = styled.button`
  ${(props) =>
    props.deleteButton &&
    `
        color: #fff;
        background-color: rgb(209, 38, 60);
        border: 1px solid rgb(209, 38, 60);
      &:hover {
        color: #fff;
        background-color: #981b1e;
        border: 1px solid rgb(209, 38, 60);
      }
  `};

  ${(props) =>
    props.cancelButton &&
    `
      font-size: 14px;
      color: rgb(0, 94, 162);
      border: none;
      background: none;
      &:hover {
        text-decoration: underline;
      }
  `};
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
`;
const RemovalContainer = styled.div`
  position: relative;
`;

const RemovalModal = styled.div`
  z-index: 9999;
  position: absolute;
  right: 0;
  width: 300px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(0, 0, 0, 0.4);
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-top: -4px;
  padding: 12px;
  font-weight: 700;
`;

const RemovalModalButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
`;

export const LinkageViewTable = ({
  formApi,
  data,
  formValues,
  schemaProps,
  row,
}) => {
  const [linkageIdList, setLinkageIdList] = useState([]);
  const [removalSelectedIds, setRemovalSelectedIds] = useState([]);
  const [isSelectionOpen, setIsSelectionOpen] = useState(false);

  const {
    machine_name,
    tableInfoHeader,
    linkages: { idFieldName, toFieldArray, itemUIName, viewTableColumn },
  } = schemaProps;
  let allRemovalSelected =
    !!removalSelectedIds?.length &&
    removalSelectedIds?.length === linkageIdList?.length;
  const toggleRemovalSelectAll = () => {
    if (allRemovalSelected) {
      setRemovalSelectedIds([]);
    } else {
      setRemovalSelectedIds([...linkageIdList?.map((item) => item)]);
    }
  };

  // Import linkages from formValues
  useEffect(() => {
    const fieldArrayValues = formValues?.[toFieldArray]?.[row]?.[machine_name];
    setLinkageIdList(fieldArrayValues || []);
  }, []);

  const updateLinkageData = (confirmed) => {
    if (confirmed) {
      const modifiedData = linkageIdList?.filter((item) => {
        return !removalSelectedIds.includes(item);
      });
      setLinkageIdList(modifiedData);
      saveLinkages({ selectedData: modifiedData, machine_name, formApi });
    }
    setRemovalSelectedIds([]);
  };

  const viewData = data.filter((item) =>
    linkageIdList?.includes(item[idFieldName])
  );
  const removalSelectedCount = removalSelectedIds?.length;

  const columns = (viewTableColumn) => {
    const lookup = {
      View790AAddendumBColumns: View790AAddendumBColumns({
        toggleRemovalSelectAll,
        allRemovalSelected,
        removalSelectedIds,
        setRemovalSelectedIds,
      }),
    };
    return lookup[viewTableColumn] ?? [{}];
  };

  return (
    <>
      <ViewTableHeader>
        <i>{tableInfoHeader}</i>
        {!!removalSelectedCount && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <span style={{ whiteSpace: "nowrap" }}>
              {removalSelectedCount} selected
            </span>
            <RemovalContainer>
              <PopupMenu
                contentStyle={{
                  borderRadius: 4,
                  border: "none",
                  background: "transparent",
                  boxShadow: "none",
                }}
                arrowStyle={{ width: 0, height: 0 }}
                trigger={
                  <Button
                    type="button"
                    className="usa-button"
                    deleteButton
                    style={{ marginLeft: 20 }}
                  >
                    Remove selected from list{" "}
                  </Button>
                }
                position="bottom right"
                closeOnDocumentClick
              >
                <RemovalModal>
                  Remove selected item(s) from this worksite?
                  <RemovalModalButtonContainer>
                    <Button
                      onClick={() => updateLinkageData(false)}
                      cancelButton
                      style={{ marginLeft: "auto" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="usa-button"
                      deleteButton
                      onClick={() => updateLinkageData(true)}
                    >
                      Remove
                    </Button>
                  </RemovalModalButtonContainer>
                </RemovalModal>
              </PopupMenu>
            </RemovalContainer>
          </div>
        )}
      </ViewTableHeader>

      <ViewContainer>
        <ReactTable
          columns={columns(viewTableColumn)}
          tableTheme="default"
          data={viewData}
          noDataComponentText="No Crops Added"
          pageSizeOptions={[10, 25, 50, 100]}
          showPagination={!!data ? data.length > 5 : false}
          tableStyle={{ marginBottom: 20 }}
          defaultSortBy={[
            {
              id: idFieldName,
              desc: false,
            },
          ]}
        />
      </ViewContainer>
      <button
        disabled={!data?.length}
        onClick={(e) => {
          if (!isSelectionOpen) {
            setIsSelectionOpen(true);
          }
        }}
        className="usa-button btn-extra-wide linkage-selection-button"
        type="button"
      >
        {!!linkageIdList?.length
          ? `Add/Manage ${itemUIName}`
          : `Add ${itemUIName}`}
      </button>
      <br />
      <br />
      {!data?.length && <span>{"No data available to import."}</span>}
      <LinkageSelectionTable
        linkageIdList={linkageIdList}
        schemaProps={schemaProps}
        formApi={formApi}
        setLinkageIdList={setLinkageIdList}
        isOpen={isSelectionOpen}
        setIsOpen={setIsSelectionOpen}
      />
    </>
  );
};
